export default function ExportsListing () {
    return(
        <h1>Exportações</h1>
    )
}